import { assert } from '@ember/debug';
import { service } from '@ember/service';
import Component from '@glimmer/component';
import { cached } from '@glimmer/tracking';
import ContactModel, {
  type ContactCustomProperty,
} from 'donor-elf-web/models/contact';
import ContactsCache from 'donor-elf-web/services/contacts-cache';

// either 'customProperty' must be provided or both 'contact' and 'customPropertyLabel'
interface ComponentArgs {
  customProperty?: ContactCustomProperty;
  contact?: ContactModel;
  customPropertyLabel?: string;
}

let UrlRegex = RegExp(/^https?:/i);

export default class ContactDetailsPropertiesCustomPropertyShowComponent extends Component<ComponentArgs> {
  constructor(owner: any, args: ComponentArgs) {
    super(owner, args);

    if (
      args.customProperty == null &&
      (args.contact == null || args.customPropertyLabel == null)
    ) {
      assert(
        'customProperty or (contact and customPropertyLabel) must be present',
        false,
      );
    }
  }
  @service declare contactsCache: ContactsCache;

  @cached
  get customProperty() {
    if (this.args.customProperty) {
      return this.args.customProperty;
    }
    return this.args.contact!.customPropertiesByLabel[
      this.args.customPropertyLabel!
    ];
  }

  get contactsCacheCustomPropertyInfo() {
    return this.contactsCache.customPropertiesByLowecaseLabel[
      this.customProperty.l.toLowerCase()
    ];
  }

  get propertyType() {
    return this.customProperty.t || this.contactsCacheCustomPropertyInfo.t;
  }

  get valueLooksLikeUrl() {
    return UrlRegex.test(this.customProperty.v);
  }

  get booleanValue() {
    return this.customProperty.v === true || this.customProperty.v === 'true'
      ? 'Yes'
      : 'No';
  }

  get listValueAsArray() {
    let allOptions = this.contactsCacheCustomPropertyInfo.o!;
    return [
      ...allOptions.filter((x) => this.customProperty.v[x]),
      // also include any keys that are not in the list of options
      ...Object.keys(this.customProperty.v).filter(
        (x) => !allOptions.includes(x),
      ),
    ];
  }

  get singleSelectionList() {
    return this.contactsCacheCustomPropertyInfo.s?.single_selection;
  }

  get singleSelectionListValue() {
    return Object.keys(this.customProperty.v)[0];
  }
}
